<template>
	<div>
		<CDialog
			:visible="show"
			:is-loading="loading"
			:title="isConfirmationDialog && newBillingPipeline ? '' : title"
			:max-width="maxWidth"
			handle-close-externally
			:hide-title-from-print="isConfirmationDialog"
			:custom-class="isConfirmationDialog ? 'change-plan-confirmation__dialog' : ''"
			@handle-close="handleClose"
		>
			<RouterView :is-hipaa-compliant="isHipaaCompliant" :use-new-billing="useNewBilling" @loading="loading = $event" @change-plan-status="changePlanStatus = $event" @close="$emit('close')" @handle-close="handleClose" />
		</CDialog>
		<CDialog
			:visible="confirmVisible"
			title="Updating Your Plan"
			max-width="450px"
		>
			<div>We're processing your plan change. This may take a few more&nbsp;moments.</div>
			<template #footer>
				<button class="button button--secondary sz-3" @click="confirmVisible = false">Okay</button>
			</template>
		</CDialog>
	</div>
</template>

<script lang="ts">
	import { defineComponent, onMounted, ref, computed, watch } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import type { ManifestJson } from '@cognitoforms/utils/manifest-helpers';
	import { fetchManifestJson, fetchContentVersion } from '@cognitoforms/utils/manifest-helpers';
	import session from '@cognitoforms/api/services/session';

	export default defineComponent({
		name: 'COrganizationPlanAndBillingDialog',
		components: {
			CDialog
		},
		props: {
			title: {
				type: String,
				required: true
			},
			show: {
				type: Boolean,
				default: false
			},
			showConfirm: {
				type: Boolean,
				default: false
			},
			maxWidth: {
				type: String,
				default: '100%'
			},
			useNewBilling: {
				type: Boolean,
				default: false
			},
			isHipaaCompliant: {
				type: Boolean,
				default: false
			}
		},
		emits: ['close', 'closed'],
		setup(props, { emit }) {
			const loading = ref(true);
			const siteManifest = ref(null);
			const changePlanStatus = ref(null);

			const shouldShowConfirm = computed(() => props.showConfirm && changePlanStatus.value === 'validating');
			const isConfirmationDialog = computed(() => props.title.trim() === 'Thank You!');
			const confirmVisible = ref(false);

			onMounted(async () => {
				const manifestVersion = await fetchContentVersion();
				const productManifestJson = await fetchManifestJson('product', manifestVersion) as ManifestJson;
				loading.value = false;
				siteManifest.value = {
					product: productManifestJson
				};
			});

			watch(() => shouldShowConfirm.value, () => {
				if (!shouldShowConfirm.value)
					confirmVisible.value = false;
			});

			const handleClose = (event) => {
				if (shouldShowConfirm.value) {
					confirmVisible.value = true;
				}
				else {
					emit('close', event);
					emit('closed', event);
				}
			};

			return {
				siteManifest,
				loading,
				changePlanStatus,
				isConfirmationDialog,
				handleClose,
				confirmVisible,
				newBillingPipeline: computed(() => session.value?.enabledFeatures.NewBillingPipeline)
			};
		}
	});
</script>